module.exports = __webpack_public_path__ + "static/media/report-button-trim-expected.956fa481.svg";